<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Resumo do Banco de Horas</div>
      </div>
      <div class="card-body">
        <div class="row highlight">
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Manual</strong>
                </div>
                <div class="card-small-info">(M)</div>
                <div class="card-value-info">{{ bank.bank_legacy }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Fechado</strong>
                </div>
                <div class="card-small-info">(A)</div>
                <div class="card-value-info">{{ bank.bank_a }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Saldo Banco Atual</strong>
                </div>
                <div class="card-small-info">(B)</div>
                <div class="card-value-info">{{ bank.bank_balance }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Aberto</strong>
                </div>
                <div class="card-small-info">(B)</div>
                <div class="card-value-info">{{ bank.bank_b }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card">
              <div class="card-body position-relative overflow-hidden">
                <div class="card-small-info">
                  <strong>Banco de Horas Total</strong>
                </div>
                <div class="card-small-info">(C) = (M) + (A) + (B)</div>
                <div class="card-value-info">{{ bank.bank_c }}</div>
                <i class="fas fa-clock card-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bank: "",
    };
  },

  methods: {
    getEntity: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "point-mirror/dashboard";

      self.$http
        .post(api)
        .then((response) => {
          self.bank = response.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted() {
    const self = this;
    self.getEntity();
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue